type Props = {
  width?: number;
  height?: number;
  fill?: string;
  stroke?: string;
  className?: string;
};

export function ShoppingCartIcon(props: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 24}
      height={props.height ?? 24}
      className={props.className}
      stroke="currentColor"
      strokeWidth={0.7}
      fill="none"
    >
      <path
        d="M9.66569 18.9993C10.0339 18.9993 10.3324 18.7009 10.3324 18.3327C10.3324 17.9645 10.0339 17.666 9.66569 17.666C9.2975 17.666 8.99902 17.9645 8.99902 18.3327C8.99902 18.7009 9.2975 18.9993 9.66569 18.9993Z"
        stroke="#593B37"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9997 18.9993C17.3679 18.9993 17.6663 18.7009 17.6663 18.3327C17.6663 17.9645 17.3679 17.666 16.9997 17.666C16.6315 17.666 16.333 17.9645 16.333 18.3327C16.333 18.7009 16.6315 18.9993 16.9997 18.9993Z"
        stroke="#593B37"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.33301 5H6.99967L8.78634 13.9267C8.8473 14.2336 9.01428 14.5093 9.25804 14.7055C9.5018 14.9018 9.80681 15.006 10.1197 15H16.5997C16.9125 15.006 17.2176 14.9018 17.4613 14.7055C17.7051 14.5093 17.872 14.2336 17.933 13.9267L18.9997 8.33333H7.66634"
        stroke="#593B37"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
